(function () {
  'use strict';

  document.querySelectorAll('[data-category-tabs-shell]').forEach(function (shell) {
    var scroller = shell.querySelector('[data-category-tabs]');
    var left = shell.querySelector('[data-category-left]');
    var right = shell.querySelector('[data-category-right]');
    if (!scroller || !left || !right) return;

    function scrollAmount() {
      return Math.max(260, Math.round(scroller.clientWidth * 0.72));
    }

    function updateArrows() {
      var maxScroll = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
      left.disabled = scroller.scrollLeft <= 2;
      right.disabled = scroller.scrollLeft >= maxScroll - 2;
    }

    left.addEventListener('click', function () {
      scroller.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
    });

    right.addEventListener('click', function () {
      scroller.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
    });

    scroller.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);
    updateArrows();
  });
}());
